import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.regexp.replace.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
var CustomerPhone = /*#__PURE__*/function (_BaseModel) {
  function CustomerPhone(props) {
    var _this;
    _classCallCheck(this, CustomerPhone);
    _this = _callSuper(this, CustomerPhone, [props]);
    _this._types = {
      1: 'Home',
      2: 'Work',
      3: 'Mobile',
      4: 'Other'
    };
    return _this;
  }
  _inherits(CustomerPhone, _BaseModel);
  return _createClass(CustomerPhone, [{
    key: "type",
    value: function type() {
      return this._types[this.get('phone_type_id')];
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return this.get('phone_type_id') === 3;
    }
  }, {
    key: "number",
    value: function number() {
      return this.get('number').replace(/^44/, '(+44)');
    }
  }, {
    key: "isPrimaryMobile",
    value: function isPrimaryMobile() {
      return this.isMobile() && this.get('is_primary_mobile');
    }
  }]);
}(BaseModel);
export default CustomerPhone;